import { render, staticRenderFns } from "./PromoSearch.vue?vue&type=template&id=038b346e"
import script from "./PromoSearch.vue?vue&type=script&lang=js"
export * from "./PromoSearch.vue?vue&type=script&lang=js"
import style0 from "./PromoSearch.vue?vue&type=style&index=0&id=038b346e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports